// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"38ebf943","337":"20a41da9","450":"84ef051f","453":"999ca568","455":"773de9ff"}[chunkId] + ".chunk.js";
};